import axios from 'axios';
import { getApiUrl } from '../config/appConfig';

export const useApi = () => {
    // Configuración para aceptar certificados autofirmados en desarrollo
    if (process.env.NODE_ENV === 'development') {
        process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
    }

    const api = axios.create({
        baseURL: getApiUrl(),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    // Interceptor para agregar el token de autenticación
    api.interceptors.request.use((config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    return api;
}; 